// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadMoreObserver_root__1_eCv","rootCenter":"LoadMoreObserver_rootCenter__2IYDl","noPaddingBottom":"LoadMoreObserver_noPaddingBottom__19qHU"};